var chunkMapping = {
	"apps_console-host_src_main_tsx": [
		60866,
		64865,
		62318,
		4924,
		76710,
		73064,
		85196,
		17369,
		61097,
		86444,
		25482,
		60487,
		42609
	]
};
var idToExternalAndNameMapping = {
	"4924": [
		"default",
		"./styles",
		67178
	],
	"17369": [
		"default",
		"./styles",
		4904
	],
	"25482": [
		"default",
		"./styles",
		2708
	],
	"42609": [
		"default",
		"./State",
		1473
	],
	"60487": [
		"default",
		"./styles",
		78434
	],
	"60866": [
		"default",
		"./styles",
		27764
	],
	"61097": [
		"default",
		"./styles",
		48758
	],
	"62318": [
		"default",
		"./styles",
		99013
	],
	"64865": [
		"default",
		"./styles",
		30849
	],
	"73064": [
		"default",
		"./styles",
		1473
	],
	"76710": [
		"default",
		"./Components",
		1473
	],
	"85196": [
		"default",
		"./styles",
		59813
	],
	"86444": [
		"default",
		"./styles",
		12011
	]
};
var idToRemoteMap = {
	"4924": [
		{
			"externalType": "script",
			"name": "dxpConfiguration",
			"externalModuleId": 67178
		}
	],
	"17369": [
		{
			"externalType": "script",
			"name": "dxpCustomerDataPlatform",
			"externalModuleId": 4904
		}
	],
	"25482": [
		{
			"externalType": "script",
			"name": "dxpMonitoring",
			"externalModuleId": 2708
		}
	],
	"42609": [
		{
			"externalType": "script",
			"name": "dxpConsoleCore",
			"externalModuleId": 1473
		}
	],
	"60487": [
		{
			"externalType": "script",
			"name": "dxpOptimization",
			"externalModuleId": 78434
		}
	],
	"60866": [
		{
			"externalType": "script",
			"name": "dxpAdministration",
			"externalModuleId": 27764
		}
	],
	"61097": [
		{
			"externalType": "script",
			"name": "dxpDigitalAssetManagement",
			"externalModuleId": 48758
		}
	],
	"62318": [
		{
			"externalType": "script",
			"name": "dxpComponentService",
			"externalModuleId": 99013
		}
	],
	"64865": [
		{
			"externalType": "script",
			"name": "dxpArtificialIntelligence",
			"externalModuleId": 30849
		}
	],
	"73064": [
		{
			"externalType": "script",
			"name": "dxpConsoleCore",
			"externalModuleId": 1473
		}
	],
	"76710": [
		{
			"externalType": "script",
			"name": "dxpConsoleCore",
			"externalModuleId": 1473
		}
	],
	"85196": [
		{
			"externalType": "script",
			"name": "dxpContentManagement",
			"externalModuleId": 59813
		}
	],
	"86444": [
		{
			"externalType": "script",
			"name": "dxpInstanceManagement",
			"externalModuleId": 12011
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}